/**
 * Generato automaticamente.
 * OpenAPI
 */
import { useQuery } from 'react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { apiClientRequest } from '../../../client/apiClient.ts';
import type { ErrorType } from '../../../client/apiClient.ts';
import type { Comune } from '../schemas/comune.ts';
import type { ComuniResponse } from '../schemas/comuniResponse.ts';
import type { GetGeolocalizzazioneComuniParams } from '../schemas/getGeolocalizzazioneComuniParams.ts';
import type { GetGeolocalizzazioneParams } from '../schemas/getGeolocalizzazioneParams.ts';
import type { GruppoComuneDto } from '../schemas/gruppoComuneDto.ts';
import type { LuogoDto } from '../schemas/luogoDto.ts';
import type { StatiEsteriResponse } from '../schemas/statiEsteriResponse.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

export const getGeolocalizzazione = (
  params: GetGeolocalizzazioneParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<LuogoDto>(
    {
      url: `/framework-cfg-domande/geolocalizzazione`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetGeolocalizzazioneQueryKey = (
  params: GetGeolocalizzazioneParams,
) =>
  [
    `/framework-cfg-domande/geolocalizzazione`,
    ...(params ? [params] : []),
  ] as const;

export const getGetGeolocalizzazioneQueryOptions = <
  TData = Awaited<ReturnType<typeof getGeolocalizzazione>>,
  TError = ErrorType<unknown>,
>(
  params: GetGeolocalizzazioneParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGeolocalizzazione>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getGeolocalizzazione>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetGeolocalizzazioneQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGeolocalizzazione>>
  > = ({ signal }) => getGeolocalizzazione(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetGeolocalizzazioneQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGeolocalizzazione>>
>;
export type GetGeolocalizzazioneQueryError = ErrorType<unknown>;

export const useGetGeolocalizzazione = <
  TData = Awaited<ReturnType<typeof getGeolocalizzazione>>,
  TError = ErrorType<unknown>,
>(
  params: GetGeolocalizzazioneParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGeolocalizzazione>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetGeolocalizzazioneQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Ottiene l'elenco degli stati esteri
 * @summary Elenco degli stati esteri
 */
export const getGeolocalizzazioneStatiEsteri = (
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<StatiEsteriResponse>(
    {
      url: `/framework-cfg-domande/geolocalizzazione/stati-esteri`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetGeolocalizzazioneStatiEsteriQueryKey = () =>
  [`/framework-cfg-domande/geolocalizzazione/stati-esteri`] as const;

export const getGetGeolocalizzazioneStatiEsteriQueryOptions = <
  TData = Awaited<ReturnType<typeof getGeolocalizzazioneStatiEsteri>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getGeolocalizzazioneStatiEsteri>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseQueryOptions<
  Awaited<ReturnType<typeof getGeolocalizzazioneStatiEsteri>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetGeolocalizzazioneStatiEsteriQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGeolocalizzazioneStatiEsteri>>
  > = ({ signal }) => getGeolocalizzazioneStatiEsteri(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetGeolocalizzazioneStatiEsteriQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGeolocalizzazioneStatiEsteri>>
>;
export type GetGeolocalizzazioneStatiEsteriQueryError = ErrorType<unknown>;

/**
 * @summary Elenco degli stati esteri
 */
export const useGetGeolocalizzazioneStatiEsteri = <
  TData = Awaited<ReturnType<typeof getGeolocalizzazioneStatiEsteri>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getGeolocalizzazioneStatiEsteri>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetGeolocalizzazioneStatiEsteriQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Ottiene l'elenco dei  gruppi dei comuni
 * @summary Elenco dei gruppi dei comuni
 */
export const getGeolocalizzazioneGruppiComuni = (
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<GruppoComuneDto[]>(
    {
      url: `/framework-cfg-domande/geolocalizzazione/gruppi-comuni`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetGeolocalizzazioneGruppiComuniQueryKey = () =>
  [`/framework-cfg-domande/geolocalizzazione/gruppi-comuni`] as const;

export const getGetGeolocalizzazioneGruppiComuniQueryOptions = <
  TData = Awaited<ReturnType<typeof getGeolocalizzazioneGruppiComuni>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getGeolocalizzazioneGruppiComuni>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseQueryOptions<
  Awaited<ReturnType<typeof getGeolocalizzazioneGruppiComuni>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetGeolocalizzazioneGruppiComuniQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGeolocalizzazioneGruppiComuni>>
  > = ({ signal }) => getGeolocalizzazioneGruppiComuni(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetGeolocalizzazioneGruppiComuniQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGeolocalizzazioneGruppiComuni>>
>;
export type GetGeolocalizzazioneGruppiComuniQueryError = ErrorType<unknown>;

/**
 * @summary Elenco dei gruppi dei comuni
 */
export const useGetGeolocalizzazioneGruppiComuni = <
  TData = Awaited<ReturnType<typeof getGeolocalizzazioneGruppiComuni>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getGeolocalizzazioneGruppiComuni>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetGeolocalizzazioneGruppiComuniQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Ottiene l'elenco dei comuni e delle province
 * @summary Elenco dei comuni
 */
export const getGeolocalizzazioneComuni = (
  params?: GetGeolocalizzazioneComuniParams,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<ComuniResponse>(
    {
      url: `/framework-cfg-domande/geolocalizzazione/comuni`,
      method: 'get',
      params,
      signal,
    },
    options,
  );
};

export const getGetGeolocalizzazioneComuniQueryKey = (
  params?: GetGeolocalizzazioneComuniParams,
) =>
  [
    `/framework-cfg-domande/geolocalizzazione/comuni`,
    ...(params ? [params] : []),
  ] as const;

export const getGetGeolocalizzazioneComuniQueryOptions = <
  TData = Awaited<ReturnType<typeof getGeolocalizzazioneComuni>>,
  TError = ErrorType<unknown>,
>(
  params?: GetGeolocalizzazioneComuniParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGeolocalizzazioneComuni>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getGeolocalizzazioneComuni>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetGeolocalizzazioneComuniQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGeolocalizzazioneComuni>>
  > = ({ signal }) =>
    getGeolocalizzazioneComuni(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetGeolocalizzazioneComuniQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGeolocalizzazioneComuni>>
>;
export type GetGeolocalizzazioneComuniQueryError = ErrorType<unknown>;

/**
 * @summary Elenco dei comuni
 */
export const useGetGeolocalizzazioneComuni = <
  TData = Awaited<ReturnType<typeof getGeolocalizzazioneComuni>>,
  TError = ErrorType<unknown>,
>(
  params?: GetGeolocalizzazioneComuniParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGeolocalizzazioneComuni>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetGeolocalizzazioneComuniQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Ottiene il comune ricercato tramite codice
 * @summary Dettaglio del comune dal codice
 */
export const getGeolocalizzazioneComuniCodice = (
  codice: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<Comune>(
    {
      url: `/framework-cfg-domande/geolocalizzazione/comuni/${codice}`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetGeolocalizzazioneComuniCodiceQueryKey = (codice: string) =>
  [`/framework-cfg-domande/geolocalizzazione/comuni/${codice}`] as const;

export const getGetGeolocalizzazioneComuniCodiceQueryOptions = <
  TData = Awaited<ReturnType<typeof getGeolocalizzazioneComuniCodice>>,
  TError = ErrorType<unknown>,
>(
  codice: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGeolocalizzazioneComuniCodice>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getGeolocalizzazioneComuniCodice>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetGeolocalizzazioneComuniCodiceQueryKey(codice);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGeolocalizzazioneComuniCodice>>
  > = ({ signal }) =>
    getGeolocalizzazioneComuniCodice(codice, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!codice, ...queryOptions };
};

export type GetGeolocalizzazioneComuniCodiceQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGeolocalizzazioneComuniCodice>>
>;
export type GetGeolocalizzazioneComuniCodiceQueryError = ErrorType<unknown>;

/**
 * @summary Dettaglio del comune dal codice
 */
export const useGetGeolocalizzazioneComuniCodice = <
  TData = Awaited<ReturnType<typeof getGeolocalizzazioneComuniCodice>>,
  TError = ErrorType<unknown>,
>(
  codice: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGeolocalizzazioneComuniCodice>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetGeolocalizzazioneComuniCodiceQueryOptions(
    codice,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Ottiene il comune ricercato tramite codice Istat
 * @summary Dettaglio del comune dal codice Istat
 */
export const getGeolocalizzazioneComuniIstatCodiceIstat = (
  codiceIstat: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<Comune>(
    {
      url: `/framework-cfg-domande/geolocalizzazione/comuni/istat/${codiceIstat}`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetGeolocalizzazioneComuniIstatCodiceIstatQueryKey = (
  codiceIstat: string,
) =>
  [
    `/framework-cfg-domande/geolocalizzazione/comuni/istat/${codiceIstat}`,
  ] as const;

export const getGetGeolocalizzazioneComuniIstatCodiceIstatQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getGeolocalizzazioneComuniIstatCodiceIstat>
  >,
  TError = ErrorType<unknown>,
>(
  codiceIstat: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGeolocalizzazioneComuniIstatCodiceIstat>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getGeolocalizzazioneComuniIstatCodiceIstat>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetGeolocalizzazioneComuniIstatCodiceIstatQueryKey(codiceIstat);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getGeolocalizzazioneComuniIstatCodiceIstat>>
  > = ({ signal }) =>
    getGeolocalizzazioneComuniIstatCodiceIstat(
      codiceIstat,
      requestOptions,
      signal,
    );

  return { queryKey, queryFn, enabled: !!codiceIstat, ...queryOptions };
};

export type GetGeolocalizzazioneComuniIstatCodiceIstatQueryResult = NonNullable<
  Awaited<ReturnType<typeof getGeolocalizzazioneComuniIstatCodiceIstat>>
>;
export type GetGeolocalizzazioneComuniIstatCodiceIstatQueryError =
  ErrorType<unknown>;

/**
 * @summary Dettaglio del comune dal codice Istat
 */
export const useGetGeolocalizzazioneComuniIstatCodiceIstat = <
  TData = Awaited<
    ReturnType<typeof getGeolocalizzazioneComuniIstatCodiceIstat>
  >,
  TError = ErrorType<unknown>,
>(
  codiceIstat: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getGeolocalizzazioneComuniIstatCodiceIstat>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetGeolocalizzazioneComuniIstatCodiceIstatQueryOptions(
      codiceIstat,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
